export function calculateDuration(startTime: Date, endTime: Date): string {
  const duration = endTime.getTime() - startTime.getTime();
  const hours = Math.floor(duration / (1000 * 60 * 60));
  const minutes = Math.floor((duration % (1000 * 60 * 60)) / (1000 * 60));

  let result = '';
  if (hours !== 0) {
    result += `${hours} ชั่วโมง`;
  }
  if (minutes !== 0) {
    result += ` ${minutes} นาที`;
  }
  return result;
}
